import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite'

import { Box } from '@material-ui/core'

import { OzonFilesTab } from '../../OzonFilesTab'
import { OzonLabelsPrintForm } from './OzonLabelsPrint'
import { RouteTabSwitchItems, RoutingTabsSwitch } from '../../RoutingTabsSwitch'

import { useOzonAccount } from '../../../hooks/routeHooks'

import { appRoutes, IntegrationRouteParams } from '../../../common/appRoutes'

export const OzonPrintPage =
  observer(() => {
    const account = useOzonAccount()

    const routes =
      useMemo(() => {
          const urlParams: IntegrationRouteParams = {
            integration: 'Ozon',
            accountId: account.id
          }

          return [{
            title: 'Этикетки',
            template: appRoutes.Store.print.labels.template,
            path: appRoutes.Store.print.labels.makeUrl(urlParams),
            render: () => <OzonLabelsPrintForm/>
          }, {
            title: 'Файлы',
            template: appRoutes.Store.print.files.template,
            path: appRoutes.Store.print.files.makeUrl(urlParams),
            render: () => <OzonFilesTab/>
          }] as const satisfies RouteTabSwitchItems
        },
        [account])

    if (!account.isDeliveryFromSellerWarehouse) {
      return (
        <Box padding={3}>
          Печать этикеток недоступна при выбранной схеме работы.
        </Box>
      )
    }

    return <RoutingTabsSwitch routeTabs={routes}/>
  })